<template>
  <div class="global__search__view">
    <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable">
			<EditModal ref="refEditModal"/>
		</b-modal>
    <b-modal hide-footer id="editWhoModal" title="Add / Update Contact" @shown="focusUpdateWhoModal">
			<UpdateWhoModal  ref="refUpdateWhoModal" />
		</b-modal>
    <b-modal hide-footer id="editDepartmentModal" title="Add / Update Department" @shown="focusModal('refUpdateDepartmentModal')">
			<UpdateDepartmentModal :departmentData="departmentData" ref="refUpdateDepartmentModal" />
		</b-modal>
    <b-modal hide-footer id="editTagModal" title="Add / Update Tag" @shown="focusModal('refUpdateTagModal')">
			<UpdateTagModal :tagData="tagData" ref="refUpdateTagModal" />
		</b-modal>
    <b-modal hide-footer id="editUserModal" 
      :title="userData.id == '' ? 'Add User' : 'Update User'" 
      @shown="focusModal('refUpdateUserModal')">
      <UpdateUserModal :userData="userData" ref="refUpdateUserModal" />
    </b-modal>
  
    
    <HeaderControls @click="triggerAddNew" @click1="sortData" :GSDataType="currentTab" :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' />
    <div class="global-search-data-wrapper fixed-top-bar-padding">
      <GlobalSearchHeader @click="activateTab" :currentTab="currentTab" />

      <div class="container-fluid">
        <div v-if="currentTab == 'all' && (globalSearchData.departments.total || globalSearchData.tags.total || globalSearchData.coordinators.total || globalSearchData.contacts.total)" class="all-title">
          <h2>
            <span class="pointer-default title-icon">
              <i class="far fa-clock"></i>
            </span>
            Most Recent
          </h2>
        </div>
        <div class="recent-search summary-wrap" v-if="(GSRecentSearch[currentTab].length > 0) || (currentTab == 'all' && (GSRecentSearch['all'].length > 0 || GSRecentSearch['tags'].length > 0 || GSRecentSearch['contacts'].length > 0 || GSRecentSearch['coordinators'].length > 0 || GSRecentSearch['departments'].length > 0))">
          <h2>
            <span class="title-icon"><i class="fas fa-history"></i></span>
            Recent Searches
            <span class="clear-search" @click="clearSearch">Clear History</span>
          </h2>
          <ul v-if="currentTab != 'all'" class="search-items">
            <li class="badge bg-primary mr-2 cursor-pointer" @click="setSearch(recentSearch)" :key="index" v-for="(recentSearch, index) in GSRecentSearch[currentTab]" v-text="recentSearch"></li>
          </ul>
          <ul v-else class="search-items">
            <li class="badge bg-primary mr-2 cursor-pointer" @click="setSearch(recentSearch)" :key="'all'+index" v-for="(recentSearch, index) in allRecentSearch" v-text="recentSearch"></li>
          </ul>
        </div>
      </div>

      <div v-if="globalSearchAll" class="container-fluid">
        <div class="">
          <h2 v-if="(!globalSearchData.departments.total && !globalSearchData.tags.total && !globalSearchData.coordinators.total && !globalSearchData.contacts.total)">No matches found. Please try a different filter.</h2>
          <div class="d-flex flex-row flex-wrap data-rows" v-else>
            <div class="summary-wrap" v-if="globalSearchData.departments.total > 0">
              <h2 class="summary-title">
                <a href="#" @click="activateTab('departments')">
                  <span class="title-icon"><i class="fas fa-project-diagram"></i></span>
                  Departments  <span class="text-muted">({{ globalSearchData.departments.total }})</span>
                </a>
              </h2>
              <ul>
                <li
                  v-for="(data,index) in globalSearchData.departments.data"
                  :key="'globalSearchDepartmentSummary'+index"
                  v-if="index<10"
                  class="cursor-pointer"
                  @click="setDeliverableDepartmentFilter(data.id, data.title)"
                >
                  <div>
                    <span class="info-bubbles">
                      <span class="initials badge badge-primary cursor-pointer">
                        {{ data.title | textInitials }}
                      </span>
                    </span>
                    <a href="#" v-if="userAbilities.editDepartment" @click.stop="updateDepartment(data)">
                      <span class="edit-contact">
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                    <p>
                      <span class="department__name cursor-pointer">{{ data.title }}<br></span>
                      <span>Used: {{ data.deliverable_count }} time(s)</span>
                    </p>
                  </div>
                </li>
              </ul>
              <a href="#" class="view-all" @click="activateTab('departments')">View All</a>
            </div>
            <div class="summary-wrap" v-if="globalSearchData.contacts.total > 0">
              <h2 class="summary-title">
                <a href="#" @click="activateTab('contacts')">
                  <span class="title-icon"><i class="far fa-id-badge"></i></span>
                  Contacts  <span class="text-muted">({{ globalSearchData.contacts.total }})</span>
                </a>
              </h2>
              <ul>
                <li
                  v-for="(data,index) in globalSearchData.contacts.data"
                  :key="'globalSearchContactSummary'+index"
                  v-if="index<10"
                  class="cursor-pointer"
                  @click="setDeliverableOutletFilter(data)"
                >
                  <div>
                    <span class="info-bubbles">
                      <span class="initials badge badge-primary">
                        {{ data.first_name + ' ' + data.last_name | textInitials }}
                      </span>
                    </span>
                    <p>
                      <span>
                        <span class="contact__name cursor-pointer">
                          {{ data.first_name + ' ' + data.last_name }} <span v-if="data.company_name">({{ data.company_name }})</span><br>
                        </span>
                        <a @click.stop="" :href="`mailto:${data.email_address}`">{{ data.email_address }}</a>
                      </span>
                      <a v-if="userAbilities.editContact || userAbilities.editMediaCall" href="#" @click.stop="updateContact(data, 'who')">
                        <span class="edit-contact">
                          <i class="fas fa-edit"></i>
                        </span>
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
              <a href="#" class="view-all" @click="activateTab('contacts')">View All</a>
            </div>
            <div class="summary-wrap" v-if="globalSearchData.coordinators.total > 0">
              <h2 class="summary-title">
                <a href="#" @click="activateTab('coordinators')">
                  <span class="title-icon"><i class="far fa-user-circle"></i></span>
                  Users  <span class="text-muted">({{ globalSearchData.coordinators.total }})</span>
                </a>
              </h2>
              <ul>
                <li
                  v-for="(data,index) in globalSearchData.coordinators.data"
                  :key="'globalSearchCoordinatorSummary'+index"
                  v-if="index<10"
                  class="cursor-pointer"
                  @click="setDeliverableCoordinatorFilter(data.id, data.name)"
                >
                  <div>
                    <span class="info-bubbles">
                      <span class="initials badge badge-primary">
                        {{ data.name | textInitials }}
                      </span>
                    </span>
                    <a href="#" v-if="userAbilities.editUser" @click.stop="updateUser(data)">
                      <span class="edit-contact">
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                    <p>
                      <span class="coordinator__name cursor-pointer">{{ data.name }} {{!data.is_enabled ? '(archived)' : ''}}<br></span>
                      <a @click.stop="" :href="`mailto:${data.email}`">{{ data.email }}</a>
                    </p>
                  </div>
                </li>
              </ul>
              <a href="#" class="view-all" @click="activateTab('coordinators')">View All</a>
            </div>
            <div class="summary-wrap" v-if="globalSearchData.tags.total > 0">
              <h2 class="summary-title">
                <a href="#" @click="activateTab('tags')">
                  <span class="title-icon"><i class="fas fa-hashtag"></i></span>
                  Tags <span class="text-muted">({{ globalSearchData.tags.total }})</span>
                </a>
              </h2>
              <ul>
                <li 
                  v-for="(data,index) in globalSearchData.tags.data" 
                  :key="'globalSearchTagSummary'+index"
                  class="cursor-pointer"
                  @click="setDeliverableTagFilter(data.id, data.tag)"
                  v-if="index<10">
                  <div>
                    <span class="info-bubbles">
                      <span class="initials badge badge-primary">
                        <i class="fas fa-hashtag"></i>
                      </span>
                    </span>
                    <p>
                      <span class="tag__name cursor-pointer">{{ data.tag }}<br></span>
                      <span>Used: {{ data.deliverable_count }} time(s)</span>
                      <a href="#" v-if="userAbilities.editTag" @click.stop="updateTag(data)">
                        <span class="edit-contact">
                          <i class="fas fa-edit"></i>
                        </span>
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
              <a href="#" class="view-all" @click="activateTab('tags')">View All</a>
            </div>
          </div>
        </div>
      </div>


      <div v-if="globalSearchDepartments" class="container-fluid">
        <div class="global-search-listing">
          <h2>
            <span class="title-icon" :class="!userAbilities.createDepartment && !userAbilities.editMediaCall ? 'pointer-default' : ''" @click="userAbilities.createDepartment || userAbilities.editMediaCall ? updateDepartment('') : ''">
              <i class="fas fa-project-diagram"></i>
              <span v-if="userAbilities.createDepartment || userAbilities.editMediaCall" class="add-item-icon">
                <img src="@/csmworkflow/img/add-icon.svg"/>
              </span>
            </span>
            Departments  <span class="text-muted">({{ globalSearchData.departments.total }})</span>
          </h2>
          <b-card-group deck>
            <b-card 
              v-for="(data,index) in globalSearchData.departments.data"
              :key="'globalSearchDepartmentSummary'+index" 
              v-if="globalSearchData.departments.total > 0"
              class="cursor-pointer"
              @click="setDeliverableDepartmentFilter(data.id, data.title)">
              <template v-slot:header>
                <span v-b-tooltip.hover :title="data.title" class="float-left truncate-text">
                  <span class="info-bubbles">
                    <span class="initials badge badge-primary">
                      {{ data.title | textInitials }}
                    </span>
                  </span>
                  <span class="department__name cursor-pointer">{{ data.title }}</span>
                </span>
                <a href="#" v-if="userAbilities.editDepartment" class="float-right" @click.stop="updateDepartment(data)">
                  <span class="edit-contact">
                    <i class="fas fa-edit"></i>
                  </span>
                </a>
              </template>
              <b-card-text class="card-detail__gs">
                Used: {{ data.deliverable_count }} time(s)
              </b-card-text>
            </b-card>
            <h2 class="ml-3" v-if="globalSearchData.departments.total == 0">
              No matches found. Please try a different filter.
            </h2>
          </b-card-group>
          <div class="pagination-wrapper" v-if="globalSearchData.departments">
            <pagination :data="globalSearchData.departments" @pagination-change-page="onPageChangeDepartments" :limit="5"></pagination>
          </div>
        </div>
      </div>
      

      <div v-if="globalSearchTags" class="container-fluid">
        <div class="global-search-listing">
          <h2>
            <span class="title-icon" :class="!userAbilities.createTag && !userAbilities.editMediaCall ? 'pointer-default' : ''" @click="userAbilities.createTag || userAbilities.editMediaCall ? updateTag('') : ''">
              <i class="fas fa-hashtag"></i>
              <span v-if="userAbilities.createTag || userAbilities.editMediaCall" class="add-item-icon">
                <img src="@/csmworkflow/img/add-icon.svg"/>
              </span>
            </span>
            Tags  <span class="text-muted">({{ globalSearchData.tags.total }})</span>
          </h2>
          <b-card-group deck>
            <b-card 
              v-for="(data,index) in globalSearchData.tags.data"
              :key="'globalSearchTagSummary'+index" 
              v-if="globalSearchData.tags.total > 0"
              class="cursor-pointer"
              @click="setDeliverableTagFilter(data.id, data.tag)">
              <template v-slot:header>
                <span class="float-left truncate-text">
                  <span class="info-bubbles">
                    <span class="initials badge badge-primary">
                      <i class="fas fa-hashtag"></i>
                    </span>
                  </span>
                  <span class="tag__name cursor-pointer">{{ data.tag }}</span>
                </span>
                <a href="#" v-if="userAbilities.editTag" class="float-right" @click.stop="updateTag(data)">
                  <span class="edit-contact">
                    <i class="fas fa-edit"></i>
                  </span>
                </a>
              </template>
              <b-card-text class="card-detail__gs">
                Used: {{ data.deliverable_count }} time(s)
              </b-card-text>
            </b-card>
            <h2 class="ml-3" v-if="globalSearchData.tags.total == 0">
              No matches found. Please try a different filter.
            </h2>
          </b-card-group>
          <div class="pagination-wrapper" v-if="globalSearchData.tags">
            <pagination :data="globalSearchData.tags" @pagination-change-page="onPageChangeTags" :limit="5"></pagination>
          </div>
        </div>
      </div>


      <div v-if="globalSearchContacts" class="container-fluid">
        <div class="global-search-listing">
          <h2>
            <span class="title-icon" :class="!userAbilities.createContact && !userAbilities.editMediaCall ? 'pointer-default' : ''" @click="userAbilities.createContact || userAbilities.editMediaCall ? updateContact('') : ''">
              <i class="far fa-id-badge"></i>
              <span v-if="userAbilities.createContact || userAbilities.editMediaCall" class="add-item-icon">
                <img src="@/csmworkflow/img/add-icon.svg"/>
              </span>
            </span>
            Contacts  <span class="text-muted">({{ globalSearchData.contacts.total }})</span>
          </h2>
          <b-card-group deck>
            <b-card 
              v-for="(data,index) in globalSearchData.contacts.data"
              :key="'globalSearchContactSummary'+index" 
              v-if="globalSearchData.contacts.total > 0"
              class="cursor-pointer"
              @click="setDeliverableOutletFilter(data)">
              <template v-slot:header>
                <span v-b-tooltip.hover :title="data.first_name + ' ' + data.last_name" class="float-left truncate-text">
                  <span class="info-bubbles">
                    <span class="initials badge badge-primary">
                      {{ data.first_name + ' ' + data.last_name | textInitials }}
                    </span>
                  </span>
                  <span class="contact__name cursor-pointer">{{ data.first_name + ' ' + data.last_name }}</span>
                </span>
                <a href="#" v-if="userAbilities.editContact || userAbilities.editMediaCall" class="float-right" @click.stop="updateContact(data, 'who')">
                  <span class="edit-contact">
                    <i class="fas fa-edit"></i>
                  </span>
                </a>
              </template>
              <b-card-text class="card-detail__gs">
                <div v-if="data.company_name" class="contact__name">{{ data.company_name }}</div>
                <a v-if="data.email_address" @click.stop="" :href="`mailto:${data.email_address}`">{{ data.email_address }}</a>
                <a v-if="data.cell_phone" @click.stop="" :href="`tel:${data.cell_phone.replace(/\D/g,'')}`">{{ data.cell_phone }}</a>
                <a v-if="data.phone" @click.stop="" :href="`tel:${data.phone.replace(/\D/g,'')}`">{{ data.phone }}</a>
              </b-card-text>
            </b-card>
            <h2 class="ml-3" v-if="globalSearchData.contacts.total == 0">
              No matches found. Please try a different filter.
            </h2>
          </b-card-group>
          <div class="pagination-wrapper" v-if="globalSearchData.contacts">
            <pagination :data="globalSearchData.contacts" @pagination-change-page="onPageChangeContacts" :limit="5"></pagination>
          </div>
        </div>
      </div>


      <div v-if="globalSearchCoordinators" class="container-fluid">
        <div class="global-search-listing">
          <h2>
            <span class="title-icon" :class="!userAbilities.createUser ? 'pointer-default' : ''" @click="userAbilities.createUser ? updateUser('') : ''">
              <i class="far fa-user-circle"></i>
              <span v-if="userAbilities.createUser" class="add-item-icon">
                <img src="@/csmworkflow/img/add-icon.svg"/>
              </span>  
            </span>
            Users  <span class="text-muted">({{ globalSearchData.coordinators.total }})</span>
            <div v-if="userAbilities.roleManager" class="float-md-right mt-3 mt-md-0">
              <b-button @click="$router.push('permission-manager')" class="header-filter-btns" variant="theme">
                Permission Manager <i class="fas fa-user-lock text-primary fa-fw float-right ml-2"></i>
              </b-button>
            </div>
          </h2>
          <b-card-group deck>
            <b-card 
              v-for="(data,index) in globalSearchData.coordinators.data"
              :key="'globalSearchCoordinatorSummary'+index" 
              v-if="globalSearchData.coordinators.total > 0"
              class="cursor-pointer"
              @click="setDeliverableCoordinatorFilter(data.id, data.name)">
              <template v-slot:header>
                <span v-b-tooltip.hover :title="data.name" class="float-left truncate-text">
                  <span class="info-bubbles">
                    <span class="initials badge badge-primary">
                      {{ data.name | textInitials }}
                    </span>
                  </span>
                  <span class="coordinator__name cursor-pointer">{{ data.name }} {{!data.is_enabled ? '(archived)' : ''}}</span>
                </span>
                <a href="#" class="float-right" v-if="userAbilities.editUser" @click.stop="updateUser(data)">
                  <span class="edit-contact">
                    <i class="fas fa-edit"></i>
                  </span>
                </a>
              </template>
              <b-card-text class="card-detail__gs">
                <a v-if="data.email" @click.stop="" :href="`mailto:${data.email}`">{{ data.email }}</a>
              </b-card-text>
            </b-card>
            <h2 class="ml-3" v-if="globalSearchData.coordinators.total == 0">
              No matches found. Please try a different filter.
            </h2>
          </b-card-group>
          <div class="pagination-wrapper" v-if="globalSearchData.coordinators">
            <pagination :data="globalSearchData.coordinators" @pagination-change-page="onPageChangeCoordinators" :limit="5"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderControls from "../components/common/HeaderControls";
import EditModal from "../components/deliverables/EditModal";
import UpdateWhoModal from "../components/deliverables/EditWhoModal";
import UpdateDepartmentModal from "../components/deliverables/EditDepartmentModal";
import UpdateTagModal from "../components/deliverables/EditTagModal";
import UpdateUserModal from "../components/deliverables/EditUserModal";
import GlobalSearchHeader from "../components/deliverables/GlobalSearchHeader";
import { mapGetters, mapActions } from 'vuex';
import toast from "../toast";

export default {
  data() {
    return {
      searchQuery: "",
      filterQuery: {},
      freshFilterTemplate: {
        query: "",
        outletCompany: [],
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        tag: [],
        department: [],
        coordinator: [],
        project: [],
        noDeparment: 'not_accepted',
        noOutlet: 'not_accepted',
        weekFilterOptions: {
          overdue: false,
          today: false,
          thisWeek: false,
          nextWeek: false,
          upcoming: false,
          noDeadline: false,
        },
      },
      globalSearchAll: true,
      globalSearchTags: false,
      globalSearchContacts: false,
      globalSearchCoordinators: false,
      globalSearchDepartments: false,
      departmentData: '',
      tagData: '',
      userData: '',
      currentTab: 'all',
      currentSort: '',
    };
  },
  components: {
    EditModal,
    UpdateWhoModal,
    HeaderControls,
    GlobalSearchHeader,
    UpdateDepartmentModal,
    UpdateTagModal,
    UpdateUserModal
  },
  computed: {
    ...mapGetters([
      'deliverableDetail',
      'globalSearchFilter',
      'globalSearchData',
      'userAbilities',
      'GSRecentSearch', 
      'defaultFilterParams'
    ]),
    allRecentSearch() {
      let recentSearches = this.GSRecentSearch['all'];
      recentSearches = recentSearches.concat(this.GSRecentSearch['tags'], this.GSRecentSearch['contacts'], this.GSRecentSearch['coordinators'], this.GSRecentSearch['departments']);
      let uniqueSearches = [...new Set(recentSearches)];
      return uniqueSearches;
    }
  },
  mounted() {
		this.fetchDepartments();
		this.fetchTags();
		this.fetchUsers();
		this.fetchGeoData();
    this.fetchAllCustomFields();
    localStorage.setItem('currentPageNumber', 1);
    localStorage.setItem('currentGSTab', 'all');
    this.activateTab(this.currentTab);
	},
  methods: {
    ...mapActions(['fetchDepartments', 'fetchTags', 'fetchUsers', 'fetchGeoData', 'fetchAllCustomFields']),
    setDeliverableDepartmentFilter(departmentId, departmentName) {
      let freshFilter = this.freshFilterTemplate;
      freshFilter.department = [{id: departmentId, name: departmentName}];
      this.$store.commit('setDashboardFilter', freshFilter);
      this.$router.push('dashboard');
    },
    setDeliverableTagFilter(tagId, tagName) {
      let freshFilter = this.freshFilterTemplate;
      freshFilter.tag = [{id: tagId, name: tagName}];
      this.$store.commit('setDashboardFilter', freshFilter);
      this.$router.push('dashboard');
    },
    setDeliverableOutletFilter(outletData) {
      let freshFilter = this.freshFilterTemplate;
      outletData.name = outletData.first_name + ' ' + outletData.last_name;
      freshFilter.outlet = [outletData];
      this.$store.commit('setDashboardFilter', freshFilter);
      this.$router.push('dashboard');
    },
    setDeliverableCoordinatorFilter(userId, userName) {
      let freshFilter = this.freshFilterTemplate;
      freshFilter.coordinator = [{id: userId, name: userName}];
      this.$store.commit('setDashboardFilter', freshFilter);
      this.$router.push('dashboard');
    },
    onPageChangeContacts(page) {
      localStorage.setItem('currentPageNumber', page);
      localStorage.setItem('currentGSTab', 'contacts');
      this.$store.dispatch('globalSearch', {page: page, type: 'contacts'});
    },
    onPageChangeTags(page) {
      localStorage.setItem('currentPageNumber', page);
      localStorage.setItem('currentGSTab', 'tags');
      this.$store.dispatch('globalSearch', {page: page, type: 'tags'});
    },
    onPageChangeDepartments(page) {
      localStorage.setItem('currentPageNumber', page);
      localStorage.setItem('currentGSTab', 'departments');
      this.$store.dispatch('globalSearch', {page: page, type: 'departments'});
    },
    onPageChangeCoordinators(page) {
      localStorage.setItem('currentPageNumber', page);
      localStorage.setItem('currentGSTab', 'coordinators');
      this.$store.dispatch('globalSearch', {page: page, type: 'coordinators'});
    },
    activateTab(activeTab) {
      // let params = '';
      // if(activeTab != 'all') {
      //   params = {page: 1, type: activeTab};
      // }
       
      // this.$store.dispatch('globalSearch', params).then(() => {
        this.globalSearchFilter.sort = '';
        this.globalSearchAll = false
        this.globalSearchTags = false
        this.globalSearchContacts = false
        this.globalSearchCoordinators = false
        this.globalSearchDepartments = false
        this.currentTab = activeTab;
        switch(activeTab) {
          case 'all':
            this.globalSearchAll = true
            this.globalSearchFilter.status = ['Active'];
            break;
          case 'tags':
            this.globalSearchTags = true
            this.globalSearchFilter.status = ['Active'];
            break;
          case 'contacts':
            this.globalSearchContacts = true
            this.globalSearchFilter.status = ['Active'];
            break;
          case 'coordinators':
            this.globalSearchCoordinators = true
            this.globalSearchFilter.status = ['Active'];
            break;
          case 'departments':
            this.globalSearchDepartments = true
            this.globalSearchFilter.status = ['Active'];
            break;
          default:
            // code block
        }  
      // })
    },
    focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    updateContact(contactData, fieldKey) {
      this.$store.state.currentContactData = contactData;
      this.$store.state.currentContactId = contactData.id;
      this.$store.state.currentFieldKey = fieldKey;
      this.$bvModal.show("editWhoModal");
    },
    updateDepartment(departmentData) {
      if(departmentData == '') {
        this.departmentData = {
          id: '', 
          abbreviation: '',
          deliverable_count: '',
          title: ''
        };
      } else {
        this.departmentData = departmentData;
      }
      this.$bvModal.show("editDepartmentModal");
    },
    updateUser(userData) {
      if(userData == '') {
        this.userData = {
          id: '', 
          name: '',
          email: '',
          password: ''
        };
      } else {
        this.userData = userData;
      }
      this.$bvModal.show("editUserModal");
    },
    updateTag(tagData) {
      if(tagData == '') {
        this.tagData = {id: '', tag: ''};
      } else {
        this.tagData = tagData;
      }
      this.$bvModal.show("editTagModal");
    },
    focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
    focusModal(ref) {
			this.$refs[ref].focusMyElement();
    },
    sortData(sortType) {
      this.$store.dispatch('globalSearch');
    },
    triggerAddNew(type) {
      switch(type) {
        case 'tag':
          if(!this.userAbilities.createTag && !this.userAbilities.editMediaCall) {
            toast.error('You do not have permission to perform this action.');
            return;
          }
          this.updateTag('');
          break;
        case 'contact':
          if(!this.userAbilities.createContact && !this.userAbilities.editMediaCall) {
            toast.error('You do not have permission to perform this action.');
            return;
          }
          this.updateContact('');
          break;
        case 'coordinator':
          if(!this.userAbilities.createUser) {
            toast.error('You do not have permission to perform this action.');
            return;
          }
          this.updateUser('');
          break;
        case 'department':
        default:
          if(!this.userAbilities.createDepartment && !this.userAbilities.editMediaCall) {
            toast.error('You do not have permission to perform this action.');
            return;
          }
          this.updateDepartment('');
          break;
      }
    },
    setSearch(query) {
      this.globalSearchFilter.query = query.trim();
      let self = this;
      this.$nextTick(() => {
        $('#search-query').val(self.globalSearchFilter.query);
      });
      this.$store.dispatch('globalSearch');
    },
    clearSearch() {
      this.$store.commit('setRecentSearch', {searchQuery: 'resetSearch', activeTab: this.currentTab})
    }
  }
};
</script>